import { Paper, styled } from '@mui/material';

export const StyledCard = styled(Paper)`
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
